// extracted by mini-css-extract-plugin
export default {"navBox":"index_navBox_cHusp","nav":"index_nav_SV8MS","navFixed":"index_navFixed_N6k-Y","navItem":"index_navItem_xYJl8","active":"index_active_kLf9G"};